import React, { Component } from 'react';
import { compose } from 'redux';
import moment from 'moment';
import {reduxForm, Field, getFormValues} from 'redux-form';
import { connect } from 'react-redux';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faArrowFromLeft from '@fortawesome/fontawesome-pro-light/faArrowFromLeft';
import faArrowToRight from '@fortawesome/fontawesome-pro-light/faArrowToRight';
import faBed from '@fortawesome/fontawesome-pro-light/faBed';
import faCalendar from '@fortawesome/fontawesome-pro-light/faCalendar';
import faMoon from '@fortawesome/fontawesome-pro-light/faMoon';

import { bookingFormInitialValues } from '../store/reducers';
import DateInput from './DateInput';
import TextInput from './TextInput';
import { formatHeaderText } from '../apiHelpers';
import { TAB_OCCUPATIONS, TAB_ROOMS } from '../constants'
import withLocalize from '../withLocalize';
import T from "./Translate";

class DepartureArrival extends Component {
	constructor(props) {
		super(props);

		this.state = {
			tab: props.tab,
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.tab !== this.props.tab && this.props.tab !== this.state.tab) {
			this.setState({ tab: this.props.tab });
		}
	}

	handleClickTab = (e) => {
		e.preventDefault();

		const tab = this.state.tab === TAB_ROOMS ? TAB_OCCUPATIONS : TAB_ROOMS;
		this.setState({ tab: tab });
		this.props.onTabChange(tab);
	};

	render() {
		const { closingDay, closingTime, eventPackage, formValues, headerText, lang, lengthOfStay, noOfNights, showRoomTypesAvailabilities, translate: t } = this.props;

		return (
            <div className="departure-arrival">
				<fieldset className="fieldset">
					<legend><T id="DepartureArrival.title" /></legend>
				</fieldset>

				{!!headerText[lang] &&
				<p className="departure-arrival__group-info">{formatHeaderText(headerText[lang])}</p>
				}

				<div className="select-row">
					{showRoomTypesAvailabilities && !eventPackage &&
					<button
						className="large-input large-input--with-big-icon select-row__item"
						onClick={e => this.handleClickTab(e)}
					>
						{this.state.tab === TAB_ROOMS &&
						<FontAwesomeIcon icon={faCalendar} className="large-input__big-icon" />
						}
						{this.state.tab === TAB_OCCUPATIONS &&
						<FontAwesomeIcon icon={faBed} className="large-input__big-icon" />
						}
						<label>{t(this.state.tab === TAB_ROOMS ? 'DepartureArrival.occupancy' : 'DepartureArrival.rooms')}</label>
					</button>
					}

					<Field
						label={t('DepartureArrival.arrival')}
						name="arrival"
						component={DateInput}
						className="select-row__item"
						fontAwesomeIconBig={faArrowToRight}
						minDate={closingDay ? moment().subtract(closingDay, 'days') : moment()}
						disabled={!!eventPackage}
					/>

					<Field
						label={t('DepartureArrival.departure')}
						name="departure"
						component={DateInput}
						className="select-row__item"
						fontAwesomeIconBig={faArrowFromLeft}
						minDate={moment().add((lengthOfStay[0] !== null ? lengthOfStay[0] : 1) - closingDay, 'days')}
						disabled={!!eventPackage}
					/>

					<TextInput
						label={t('DepartureArrival.noOfNights')}
						value={noOfNights}
						disabled
						className="select-row__item"
						fontAwesomeIconBig={faMoon}
						inputContainer={false}
					/>
				</div>

				{(closingDay !== 0 || !!closingTime) && moment().subtract(closingDay, 'days').format('D.M.YYYY') === formValues.arrival &&
				<p className="departure-arrival__closing-time">{t('DepartureArrival.closingTime', { closingTime: closingTime })}</p>
				}

            </div>
		);
	}
}


export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		closingDay: state.app.closingDay,
		closingTime: state.app.closingTime,
		eventPackage: state.app.package,
		formValues: getFormValues('bookingForm')(state),
		headerText: state.app.headerText,
		lengthOfStay: state.app.lengthOfStay,
		noOfNights: state.app.noOfNights,
		showRoomTypesAvailabilities: state.app.showRoomTypesAvailabilities,
	})),
	withLocalize,
)(DepartureArrival);


// WEBPACK FOOTER //
// ./src/components/DepartureArrival.jsx